export default [
    // {
    //     path: '/thirdapp/aiarticlehelper',
    //     name: 'AI发布任务',
    //     meta: {
    //         title: 'AI发布任务',
    //         parent: '/cms/navigation',

    //     },
    //     component: () => import('views/modules/AITask/index.vue'),
    // },
    {
        path: '/thirdapp/aiarticlehelper/detail',
        component: () => import('views/modules/AITask/detail.vue'),
        meta: {
            parent: '/thirdapp/aiarticlehelper',
            title: 'AI发布任务',
        },
    },
    
];